import { getItem } from '../helpers/object-helper';
import { optionValueForGuiConfigurationState } from '../helpers/gui-helper';
import { goolgeLibMapsGet } from '../helpers/google-lib-discover-helper';

const googleMaps = goolgeLibMapsGet();
const confUrlBasePathname = process.env.PUBLIC_URL;

const confData = {
    // web api
    api: {
        development: {
            //baseUrl: 'http://localhost:3001'
            baseUrl: 'https://bernoulli.amtek.site/iesccapitest',
        },
        production: {
            baseUrl: 'https://bernoulli.amtek.site/iesccapi/',
            //baseUrl: 'https://bernoulli.amtek.site/iesccapitest'
        },
    },
    // gui data
    gui: {
        loading: {
            label: 'Stiamo elaborando la tua richiesta',
        },
        images: {
            basePath:
                process.env.NODE_ENV === 'development'
                    ? '/images'
                    : `${confUrlBasePathname}/images`,
        },
        docs: {
            basePath:
                process.env.NODE_ENV === 'development'
                    ? '/docs'
                    : `${confUrlBasePathname}/docs`,
        },
        map: {
            _k: 'AIzaSyDaJLwsUmFr05RY1WbrzQ-V8suIicSFzIg',
            imageGeneratorUrl: 'https://maps.googleapis.com/maps/api/staticmap',
            address: 'Piazza Duomo, Milano',
            addressMarkerIcon: {
                path: googleMaps
                    ? googleMaps.SymbolPath.BACKWARD_CLOSED_ARROW
                    : null,
                fillColor: '#FF9D2E',
                fillOpacity: 1,
                strokeColor: 'white',
                strokeWeight: 1,
                scale: 4,
                rotation: 30,
            },
            mapOptions: {
                zoom: 18,
                mapTypeId: googleMaps ? googleMaps.MapTypeId.SATELLITE : null,
            },
            drawingManagerOptions: {},
            polygonOptions: {
                strokeWeight: 0,
                fillOpacity: 0.75,
                fillColor: '#FF9D2E',
                editable: true,
                draggable: true,
            },
            mapStaticImage: {
                generatorUrl: 'https://maps.googleapis.com/maps/api/staticmap',
                size: '400x400',
                sizeInQuotationsComponent: '463x204', //'331x204',
                scale: 1,
            },
        },
        steps: {
            step1: {
                dataId: 'configuration.tipo_installazione',
                title: 'Configura il tuo climatizzatore',
                text: 'In quale immobile vuoi installare il climatizzatore?',
                options: [
                    {
                        label: 'Abitazione principale: detrazione fiscale 50%',
                        value: 'abitazione_principale',
                    },
                    {
                        label: 'Altro immobile: detrazione fiscale 36%',
                        value: 'altro_immobile',
                    },
                ],
                nextValidationFailMessage:
                    "E' necessario selezionare un'opzione",
                //nextAuto: false // activate this to disable nextAuto feature on the step
            },
            step2: {
                dataId: 'configuration.dove',
                title: 'Configura il tuo climatizzatore',
                text: "Dove intendi posizionare l'unità esterna?",
                info: '(La distanza tra gli split e l’unità esterna non deve essere superiore ai 13 mt)',
                options: [
                    {
                        label: 'A terra',
                        value: 'terra',
                    },
                    {
                        label: 'A parete',
                        value: 'parete',
                    },
                    {
                        label: 'A tetto',
                        value: 'tetto',
                    },
                ],
                nextValidationFailMessage:
                    "E' necessario selezionare un'opzione",
            },
            step3: {
                dataId: 'configuration.numero_stanze',
                title: 'Configura il tuo climatizzatore',
                text: 'Quante stanze devi condizionare?',
                options: [
                    {
                        label: 'Solo una stanza',
                        value: 'una_stanza',
                    },
                    {
                        label: 'Due stanze o più',
                        value: 'due_stanze_o_piu',
                    },
                ],
                nextValidationFailMessage:
                    "E' necessario selezionare un'opzione",
            },
            step4: {
                dataId: 'configuration.numero_clima_per_stanza',
                title: 'Configura il tuo climatizzatore',
                text: 'Inserisci il numero dei clima necessari per raffrescare le vostre stanze',
                tableData: [
                    {
                        dataId: 'numero_clima_per_stanza_mono9',
                        label: 'Monosplit 9000',
                        mq: '25mq',
                    },
                    {
                        dataId: 'numero_clima_per_stanza_mono12',
                        label: 'Monosplit 12000',
                        mq: '35mq',
                    },
                    {
                        dataId: 'numero_clima_per_stanza_mono18',
                        label: 'Monosplit 18000',
                        mq: '50mq',
                    },
                    {
                        dataId: 'numero_clima_per_stanza_dual9_9',
                        label: 'Dualsplit 9000+9000',
                        mq: '50mq',
                    },
                    {
                        dataId: 'numero_clima_per_stanza_dual9_12',
                        label: 'Dualsplit 9000+12000',
                        mq: '60mq',
                    },
                    {
                        dataId: 'numero_clima_per_stanza_trial9_9_9',
                        label: 'Trial 9000+9000+9000',
                        mq: '80mq',
                    },
                    {
                        dataId: 'numero_clima_per_stanza_trial9_9_12',
                        label: 'Trial 9000+9000+12000',
                        mq: '90mq',
                    },
                ],
                options: [
                    {
                        label: '0',
                        value: '',
                    },
                    {
                        label: '1',
                        value: 1,
                    },
                    {
                        label: '2',
                        value: 2,
                    },
                    {
                        label: '3',
                        value: 3,
                    },
                    {
                        label: '4',
                        value: 4,
                    },
                    {
                        label: '5',
                        value: 5,
                    },
                    {
                        label: '6',
                        value: 6,
                    },
                    {
                        label: '7',
                        value: 7,
                    },
                    {
                        label: '8',
                        value: 8,
                    },
                    {
                        label: '9',
                        value: 9,
                    },
                    {
                        label: '10',
                        value: 10,
                    },
                ],
                nextValidationFailMessage:
                    "E' necessario selezionare almeno un climatizzatore",
                nextAuto: false,
            },
            step5: {
                dataId: 'configuration.marchi',
                title: 'Configura il tuo climatizzatore',
                text: 'Su quale marchio avresti preferenza?',
                options: [
                    {
                        label: 'Unical Flowy',
                        value: 'unical_flowy',
                    },
                    {
                        label: 'Unical Multi Cristal',
                        value: 'unical_multi_cristal',
                    },
                    {
                        label: 'Samsung WindFree',
                        value: 'samsung_windfree',
                    },
                    {
                        label: 'Mitsubishi A/P',
                        value: 'mitsubishi_ap',
                    },
                    {
                        label: 'Hisense',
                        value: 'hisense',
                    },
                    {
                        label: 'Non ho preferenze',
                        value: 'non_ho_preferenze',
                    },
                ],
                nextValidationFailMessage:
                    "E' necessario selezionare un marchio",
            },
            step6: {
                dataId: 'configuration.scarico_4mt_discesa',
                title: 'Configura il tuo climatizzatore',
                text: 'Lo scarico più vicino si trova a meno di 4 mt di distanza con tratto sempre in discesa?',
                options: [
                    {
                        label: 'Si',
                        value: 'si',
                    },
                    {
                        label: 'No, necessario convogliarlo a più di 4 mt contropendenza',
                        value: 'no_contropendenza',
                    },
                    {
                        label: 'Lasciare lo scarico di condensa in tanica',
                        value: 'tanica',
                    },
                ],
                nextValidationFailMessage:
                    "E' necessario selezionare un'opzione",
            },
            step7: {
                dataId: 'configuration.unita_esterna_2_5mt',
                title: 'Configura il tuo climatizzatore',
                text: 'L’installazione dell’unità esterna è a meno di 2,5 mt di altezza?',
                options: [
                    {
                        label: 'Si',
                        value: 'si',
                    },
                    {
                        label: 'No',
                        value: 'no',
                    },
                ],
                nextValidationFailMessage:
                    "E' necessario selezionare un'opzione",
            },
            step8: {
                title: 'Configura il tuo climatizzatore',
                dataId: 'configuration.parete_cemento_pietra',
                parete: {
                    dataId: 'configuration.parete_cemento_pietra',
                    text: 'La parete da forare è in cemento armato o pietra maggiore di 30cm?',
                    options: [
                        {
                            label: 'Si',
                            value: 'si',
                        },
                        {
                            label: 'No',
                            value: 'no',
                        },
                    ],
                },
                quantePareti: {
                    dataId: 'configuration.quante_pareti_attraversare',
                    text: 'Quante pareti dobbiamo attraversare?',
                    options: [
                        {
                            label: '',
                            value: '',
                        },
                        {
                            label: '1',
                            value: '1',
                        },
                        {
                            label: '2',
                            value: '2',
                        },
                        {
                            label: '3',
                            value: '3',
                        },
                        {
                            label: '4',
                            value: '4',
                        },
                        {
                            label: '5',
                            value: '5',
                        },
                        {
                            label: '6',
                            value: '6',
                        },
                    ],
                },
                nextValidationFailMessage:
                    "E' necessario selezionare un'opzione e, se richiesto, quante pareti attraversare",
                nextAuto: false,
            },
        },
        quotations: {
            title: 'Proposta installativa',
        },
        configurationState: {
            user: {
                exclude: ['pv', 'city', 'postalCode'],
            },
            configuration: {
                exclude: [
                    'electricityConsumptionPersone',
                    'electricityConsumptionCost',
                ],
            },
        },
    },
    // user data
    user: {
        address: {
            label: 'Indirizzo',
            webServiceParamName: 'indirizzo',
        },
        pv: {
            label: 'Provincia',
        },
        city: {
            label: 'Città',
        },
        postalCode: {
            label: 'Codice postale',
        },
        email: {
            label: 'Email',
        },
    },
    // quotationsForm data
    quotationsForm: {
        nome: {
            label: 'Nome',
        },
        cognome: {
            label: 'Cognome',
        },
        email: {
            label: 'Email',
        },
        ragioneSociale: {
            label: 'Ragione sociale',
        },
        indirizzo: {
            label: 'Indirizzo',
        },
        numerocivico: {
            label: 'Numero civico',
            webServiceParamName: 'numeroCivico',
        },
        comune: {
            label: 'Comune',
        },
        cap: {
            label: 'CAP',
        },
        provincia: {
            label: 'Provincia',
        },
        tipoImmobile: {
            label: 'Tipo di appartamento',
        },
    },
    // Configuration for ConfigurationState Component
    configuration: {
        tipo_installazione: {
            label: 'Tipo di installazione',
            valueGuiForConfigurationStateFn: (value) => {
                const confDataForStep = confData.gui.steps.step1;
                return optionValueForGuiConfigurationState(
                    confDataForStep,
                    value
                );
            },
        },
        dove: {
            label: 'Posizionamento',
            valueGuiForConfigurationStateFn: (value) => {
                const confDataForStep = confData.gui.steps.step2;
                return optionValueForGuiConfigurationState(
                    confDataForStep,
                    value
                );
            },
        },
        numero_stanze: {
            label: 'Numero di stanze',
            valueGuiForConfigurationStateFn: (value) => {
                const confDataForStep = confData.gui.steps.step3;
                return optionValueForGuiConfigurationState(
                    confDataForStep,
                    value
                );
            },
        },
        numero_clima_per_stanza: {
            label: 'Numero clima per stanza',
            valueGuiForConfigurationStateFn: (value) => {
                const confDataForStep = confData.gui.steps.step4;
                return optionValueForGuiConfigurationState(
                    confDataForStep,
                    value
                );
            },
        },
        numero_clima_per_stanza_mono9: {
            label: 'Monosplit 9000',
            valueGuiForConfigurationStateFn: (value) => {
                const confDataForStep = confData.gui.steps.step4;
                return optionValueForGuiConfigurationState(
                    confDataForStep,
                    value
                );
            },
        },
        numero_clima_per_stanza_mono12: {
            label: 'Monosplit 12000',
            valueGuiForConfigurationStateFn: (value) => {
                const confDataForStep = confData.gui.steps.step4;
                return optionValueForGuiConfigurationState(
                    confDataForStep,
                    value
                );
            },
        },
        numero_clima_per_stanza_mono18: {
            label: 'Monosplit 18000',
            valueGuiForConfigurationStateFn: (value) => {
                const confDataForStep = confData.gui.steps.step4;
                return optionValueForGuiConfigurationState(
                    confDataForStep,
                    value
                );
            },
        },
        numero_clima_per_stanza_dual9_9: {
            label: 'Dualsplit 9000+9000',
            valueGuiForConfigurationStateFn: (value) => {
                const confDataForStep = confData.gui.steps.step4;
                return optionValueForGuiConfigurationState(
                    confDataForStep,
                    value
                );
            },
        },
        numero_clima_per_stanza_dual9_12: {
            label: 'Dualsplit 9000+12000',
            valueGuiForConfigurationStateFn: (value) => {
                const confDataForStep = confData.gui.steps.step4;
                return optionValueForGuiConfigurationState(
                    confDataForStep,
                    value
                );
            },
        },
        numero_clima_per_stanza_trial9_9_9: {
            label: 'Trial 9000+9000+9000',
            valueGuiForConfigurationStateFn: (value) => {
                const confDataForStep = confData.gui.steps.step4;
                return optionValueForGuiConfigurationState(
                    confDataForStep,
                    value
                );
            },
        },
        numero_clima_per_stanza_trial9_9_12: {
            label: 'Trial 9000+9000+12000',
            valueGuiForConfigurationStateFn: (value) => {
                const confDataForStep = confData.gui.steps.step4;
                return optionValueForGuiConfigurationState(
                    confDataForStep,
                    value
                );
            },
        },
        marchi: {
            label: 'Su quale marchio avresti preferenza?',
            valueGuiForConfigurationStateFn: (value) => {
                const confDataForStep = confData.gui.steps.step5;
                return optionValueForGuiConfigurationState(
                    confDataForStep,
                    value
                );
            },
        },
        scarico_4mt_discesa: {
            label: 'Lo scarico più vicino si trova a meno di 4 mt di distanza con tratto sempre in discesa?',
            valueGuiForConfigurationStateFn: (value) => {
                const confDataForStep = confData.gui.steps.step6;
                return optionValueForGuiConfigurationState(
                    confDataForStep,
                    value
                );
            },
        },
        unita_esterna_2_5mt: {
            label: 'L’installazione dell’unità esterna a meno di 2,5 mt di altezza?',
            valueGuiForConfigurationStateFn: (value) => {
                const confDataForStep = confData.gui.steps.step7;
                return optionValueForGuiConfigurationState(
                    confDataForStep,
                    value
                );
            },
        },
        parete_cemento_pietra: {
            label: 'La parete da forare è in cemento armato o pietra maggiore di 30cm?',
            valueGuiForConfigurationStateFn: (value) => {
                const confDataForStep = confData.gui.steps.step8.parete;
                return optionValueForGuiConfigurationState(
                    confDataForStep,
                    value
                );
            },
        },
        quante_pareti_attraversare: {
            label: 'Quante pareti dobbiamo attraversare?',
            valueGuiForConfigurationStateFn: (value) => {
                const confDataForStep = confData.gui.steps.step8.quantePareti;
                return optionValueForGuiConfigurationState(
                    confDataForStep,
                    value
                );
            },
        },
    },
    externalUrls: {
        ies: 'https://ies-solare.com/',
        unauthorized: 'https://preventivatore.ies-solare.com/clima/',
    },
};

/**
 * Returns the application's url base path
 * @returns {String}
 */
const getConfUrlBasePathName = () => confUrlBasePathname;

/**
 * Returns a configuration item
 * @param {String} itemPath
 * @param {Object} object
 * @return {Mixed}
 *
 * @usage
 *  const item = getConfItem('configuration');
 *  const item = getConfItem('configuration.roofArea.label');
 */
const getConfItem = (itemPath, object = confData) => {
    return getItem(itemPath, object);
};

const getLabel = (itemPath, defaultLabel = '') => {
    return getConfItem(itemPath + '.label') || defaultLabel;
};

const getMeasureUnit = (itemPath, defaultMeasureUnit = '') => {
    return getConfItem(itemPath + '.measureUnit') || defaultMeasureUnit;
};

const getValueProcessFn = (itemPath) => {
    return getConfItem(itemPath + '.valueProcessFn');
};

const getValueGuiFn = (itemPath) => {
    return getConfItem(itemPath + '.valueGuiFn');
};

const getValueGuiForConfigurationStateFn = (itemPath) => {
    return getConfItem(itemPath + '.valueGuiForConfigurationStateFn');
};

const getWebServiceParamName = (itemPath) => {
    return getConfItem(itemPath + '.webServiceParamName');
};

const getWebServiceValueFn = (itemPath) => {
    return getConfItem(itemPath + '.webServiceValueFn');
};

const getStepConf = (stepNum) => {
    return getConfItem('gui.steps.step' + stepNum);
};

const getStepTitle = (stepNum) => {
    return getStepConf(stepNum) ? getStepConf(stepNum).title : '';
};

const getStepsNumber = () => {
    return Object.keys(getConfItem('gui.steps')).length;
};

const getQuotationsTitle = () => {
    return getConfItem('gui.quotations.title');
};

export default confData;
export {
    confUrlBasePathname,
    getConfUrlBasePathName,
    getConfItem,
    getLabel,
    getMeasureUnit,
    getValueProcessFn,
    getValueGuiFn,
    getValueGuiForConfigurationStateFn,
    getWebServiceParamName,
    getWebServiceValueFn,
    getStepConf,
    getStepTitle,
    getStepsNumber,
    getQuotationsTitle,
};
